import { render, staticRenderFns } from "./Stage.vue?vue&type=template&id=a136e22a"
import script from "./Stage.vue?vue&type=script&lang=js"
export * from "./Stage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a136e22a')) {
      api.createRecord('a136e22a', component.options)
    } else {
      api.reload('a136e22a', component.options)
    }
    module.hot.accept("./Stage.vue?vue&type=template&id=a136e22a", function () {
      api.rerender('a136e22a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/tasks/views/Stage.vue"
export default component.exports